import React, { useState, useRef, useEffect } from "react";
import { Helmet, HelmetProvider } from 'react-helmet-async';
import PropTypes from "prop-types";
import Footer from "../components/footer";
import { Link } from "react-router-dom";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import MapSingle from "../components/map/MapSingle";
import Gotop from "../components/gotop";
import lo1 from "../assets/images/logo-company/cty4.png";
import { Rating } from "react-simple-star-rating";
import StarProgress from "../components/progressBar/StarProgress";
import Video from "../components/popup/Video";
import Gallery from "../components/popup/Gallery";
import { Collapse } from "react-collapse";
import logo from "../assets/images/logo.png";
import Header03 from "../components/header/Header03";
import MobileHeader from "../components/header/MobileHeader";
import Avatar from 'react-avatar';

import { redirectInternal, setToken, setToStorage, logoutUser, removeToken, decodeToken } from "../services/authService"

const marKers = [
  {
    id: 1,
    title: "Rockstar Games New York",
    name: "Senior UI/UX Designer",
    address: "Las Vegas, NV 89107, USA",
    longitude: -74.00122,
    latitude: 40.71023,
    img: lo1,
  },
];

Employersingle_v1.propTypes = {};

function Employersingle_v1(props) {
  const [rating, setRating] = useState(0);
  const progressRef = useRef();
  const [targetHeight, setTargetHeight] = useState(0);
  const [toggle, setToggle] = useState({
    key: "",
    status: false,
  });
  const [isShowMobile, setShowMobile] = useState(false);
  const [showAlert, setShowAlert] = useState(false);

  const handleRating = (rate) => {
    setRating(rate);
  };
  const handleToggle = (key) => {
    if (toggle.key === key) {
      setToggle({
        status: false,
      });
    } else {
      setToggle({
        status: true,
        key,
      });
    }
  };

  const handleMobile = () => {
    const getMobile = document.querySelector(".menu-mobile-popup");
    setShowMobile(!isShowMobile);
    !isShowMobile
      ? getMobile.classList.add("modal-menu--open")
      : getMobile.classList.remove("modal-menu--open");
  };

  useEffect(() => {
    if (progressRef?.current) {
      const offsetHeight = progressRef?.current?.offsetTop;
      setTargetHeight(offsetHeight);
    }
  }, [progressRef]);

  function Alert({ title, message, onConfirm, onCancel }) {
    return (
      <div style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,0.4)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}>
        <div style={{
          background: "#fff",
          padding: 20,
          borderRadius: 8,
          width: "50%",
        }}>
          <h3>{title}</h3>
          <br />
          <p>{message}</p>

          <div style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: 10,
            marginTop: 20,
          }}>
            <button onClick={onCancel}>Cancel</button>
            <button onClick={onConfirm}>Confirm</button>
          </div>
        </div>
      </div>
    );
  }

  const handleLogout = async () => {
    try {
      setShowAlert(true);
    } catch (error) {

    }
  }

  const user = decodeToken()

  return (
    <>
      <HelmetProvider>
        <Helmet>
          <title>UKICNEWS - Profile | {localStorage.getItem("username")}</title>
          <meta
            name="description"
            content="Stay updated with the latest UK immigration news, visa changes, sponsorship jobs, and clear policy explanation for Business, Family Sponsorship, study, work, visit, ILR and more. UKICNEWS delivers trusted and timely immigration updates."
          />
          <link rel="canonical" href="https://www.ukicnews.com/profile" />

          {/* Open Graph (Facebook / LinkedIn preview) */}
          <meta property="og:type" content="website" />
          <meta property="og:title" content={`UKICNEWS | Profile ${localStorage.getItem("username")}`} />
          <meta
            property="og:description"
            content="Get reliable UK immigration updates, visa news, and sponsorship job opportunities."
          />
          <meta property="og:url" content="https://www.ukicnews.com/profile" />
          <meta property="og:image" content="https://www.ukicnews.com/preview.png" />

          {/* Twitter preview */}
          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:title" content={`UKICNEWS | Profile ${localStorage.getItem("username")}`} />
          <meta
            name="twitter:description"
            content="Stay updated with UK immigration rules and sponsorship jobs."
          />
          <meta name="twitter:image" content="https://www.ukicnews.com/preview.png" />
        </Helmet>
      </HelmetProvider>
      <MobileHeader handleMobile={handleMobile} />
      <Header03 clname="actEm2" handleMobile={handleMobile} />

      <section className="form-sticky fixed-space">
        <div className="tf-container">
          {showAlert && (
            <Alert
              title="Are you sure you want to logout?"
              message="We are going to miss you, but don't take long"
              onCancel={() => setShowAlert(false)}
              onConfirm={() => {
                logoutUser();
                removeToken();

                return redirectInternal("/");
              }}
            />
          )}
          <div className="row">
            <div className="col-lg-12">
              <div className="wd-job-author stc-em">
                <div className="inner-job-left">
                  <Avatar className="logo-company" size="100" name={localStorage.getItem("username")} />
                  <div className="content">
                    <h3>
                      <Link to="#">{localStorage.getItem("username")}</Link>&nbsp;
                      <span className="icon-bolt"></span>
                    </h3>
                    <div className="job-info">
                      <span>{localStorage.getItem("email")}</span>
                    </div>
                    <div className="job-info">
                      <span>{user.email}</span>
                    </div>
                    {/* <div className="group-btn">
                      <Link to="/pricing" className="tf-btn">Update Subscription</Link>
                    </div> */}
                    <div className="group-btn mt-3">
                      <Link onClick={handleLogout} className="tf-btn">Logout</Link>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
      <Gotop />
    </>
  );
}

export default Employersingle_v1;
